export default {
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    close: "Cerrar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Añadir",
    search: "Buscar",
    loading: "Cargando…",
    saving: "Guardando…",
    retry: "Reintentar",
    back: "Volver",
    next: "Siguiente",
    yes: "Sí",
    no: "No",
    all: "Todos",
    none: "Ninguno",
    noData: "Sin datos",
    error: "Ha ocurrido un error.",
    seeMore: "Ver más",
    seeDetail: "Ver detalle",
  },
};
